<template>
  <ibox>
    <template slot="title">口コミ登録</template>
    <template slot="body">
      <review-form></review-form>
    </template>
  </ibox>
</template>

<script>
import ReviewForm from '../../../components/company/review/Form.vue'

export default {
  data () {
    return {}
  },
  components: {
    ReviewForm
  }
}
</script>




// WEBPACK FOOTER //
// Create.vue?04511a40